import React from 'react';
import {
    Box,
    Typography,
    IconButton,
    Modal
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import registerbackground from "../images/registrationSuccess.PNG";
import successIcon from "../images/successIcon.png";
import downArrow from "../images/downArrow.png";

const MessengerModal = ({ open, onClose }) => {
    const handleClose = () => {
        if (onClose) onClose();
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="messenger-app-only"
            aria-describedby="messenger-download-prompt"
        >
            <Box
                sx={{
                    width: '100%',
                    minHeight: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    p: 2,
                }}
            >
                <Box
                    sx={{
                        position: 'relative',
                        borderRadius: '16px',
                        p: { xs: 3, sm: 5 },
                        maxWidth: 700,
                        width: '100%',
                        textAlign: 'center',
                        backgroundImage: `url(${registerbackground})`,
                        backgroundSize: '100% 100%',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        color: '#000',

                        '@media (max-width:600px)': {
                            backgroundSize: 'cover',
                            borderRadius: '12px',
                            p: 2,
                        },
                    }}
                >
                    {/* Close Icon */}
                    <IconButton
                        onClick={handleClose}
                        sx={{ position: 'absolute', top: 10, right: 10, color: '#000' }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {/* Icon Box */}
                    <Box
                        sx={{
                            backgroundColor: '#E6FBF1',
                            width: 80,
                            height: 80,
                            mx: 'auto',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 3,
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                            backgroundImage: `url(${successIcon})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    />

                    {/* Updated Title & Message */}
                    <Typography fontFamily='Montserrat' fontSize={28} fontWeight={700} gutterBottom>
                        Messenger Feature Available Only on App
                    </Typography>
                    <Typography fontFamily='Montserrat' fontSize={18} fontWeight={400} sx={{ mb: 6 }}>
                        To chat with other members, please download our mobile app using the links below.
                    </Typography>

                    {/* Available on Text */}
                    <Typography fontFamily='Montserrat' fontSize={18} fontWeight={400} sx={{ mb: 3 }}>
                        Available on
                    </Typography>

                    {/* Down Arrow */}
                    <Box
                        component="img"
                        src={downArrow}
                        alt="Down Arrow"
                        sx={{
                            width: { xs: '25px', sm: '30px', md: '35px' },
                            height: { xs: '25px', sm: '30px', md: '35px' },
                            mb: 3
                        }}
                    />

                    {/* App Store Buttons */}
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
                        <a
                            href="https://apps.apple.com/in/app/ind-matrimony/id6741297825"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                                alt="App Store"
                                style={{ height: 40, marginRight: 10 }}
                            />
                        </a>
                        <a
                            href="https://play.google.com/store/apps/details?id=com.indmatrimony.ind_matrimony"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                                alt="Google Play"
                                style={{ height: 40 }}
                            />
                        </a>
                    </Box>

                    {/* Final CTA Text */}
                    <Typography
                        fontWeight={600}
                        fontSize={20}
                        fontFamily='Montserrat'
                        sx={{
                            background: 'linear-gradient(90.07deg, #FF7705 39.28%, #E60000 99.93%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            display: 'inline-block',
                        }}
                    >
                        Don’t miss out, install the app and get started!
                    </Typography>
                </Box>
            </Box>
        </Modal>
    );
};

export default MessengerModal;
